module.exports = __webpack_public_path__ + "img/perfil-section.13ed58cc.png";